import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';

import { CmoveQuotaBarComponent } from '../components/cmove-quota-bar/cmove-quota-bar.component';
import { BffIntegrationTestComponent } from './components/bff-integration-test/bff-integration-test.component';
import { DicomViewerDialogComponent } from './components/dicom-viewer-dialog/dicom-viewer-dialog.component';
import { StudiesResultsTableComponent } from './components/studies-results-table/studies-results-table.component';
import { StudyShareStatusBadgeComponent } from './components/study-share-status-badge/study-share-status-badge.component';
import { StudyShareHistoryComponent } from './components/study-share-history/study-share-history.component';
import { StudyResharePendingComponent } from './components/study-reshare-pending/study-reshare-pending.component';
import { StudyShareDashboardComponent } from './components/study-share-dashboard/study-share-dashboard.component';
import { StudySharePatientHistoryModalComponent } from './components/study-share-patient-history-modal/study-share-patient-history-modal.component';
import { StudySearchFormComponent } from './components/study-search-form/study-search-form.component';
import { StudiesPageComponent } from './pages/studies-page/studies-page.component';

@NgModule({
  declarations: [
    StudiesPageComponent,
    StudySearchFormComponent,
    StudiesResultsTableComponent,
    BffIntegrationTestComponent,
    DicomViewerDialogComponent,
    CmoveQuotaBarComponent,
    StudyShareStatusBadgeComponent,
    StudyShareHistoryComponent,
    StudyResharePendingComponent,
    StudyShareDashboardComponent,
    StudySharePatientHistoryModalComponent,
  ],
  exports: [
    StudiesPageComponent,
    StudySearchFormComponent,
    StudiesResultsTableComponent,
    DicomViewerDialogComponent,
    CmoveQuotaBarComponent,
    StudyShareStatusBadgeComponent,
    StudyShareHistoryComponent,
    StudyResharePendingComponent,
    StudyShareDashboardComponent,
    StudySharePatientHistoryModalComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
  ],
})
export class StudiesModule {}
